<script lang="ts">
import { PRICE_REVISION_NEWS_PATH } from "$lib/price-revision";
</script>

<a
  href={PRICE_REVISION_NEWS_PATH}
  class="block w-full border-b border-solid border-primary bg-white px-4 py-3 sm:px-10 hover:bg-bgGray"
>
  <p class="mb-0.5 text-sm font-bold tracking-wide text-primary sm:text-base">
    📢 料金改定のお知らせ
  </p>
  <p class="mb-0 text-xs tracking-wide text-textGray sm:text-sm">
    11月スタート以降の講座は新料金が適用されます → 詳細を確認する
  </p>
</a>
